import Image, { StaticImageData } from 'next/image';

import SwissLogo from './svgs/swiss-logo.svg';

export const IconSwissLogo = () => (
  <Image src={SwissLogo as StaticImageData} alt="Swiss logo" width={78} height={26} />
);
